import React, {useState} from "react";
import PendingBilling from "./pendingBilling";
import Invoices from "./invoices";
import Settings from "./settings";
import {useHistory} from "react-router-dom";
import {HREF_PAGE_HELP} from "../../../models/constants";

export default function Navigation({points_of_sale}) {
  const [activeTab, setActiveTab] = useState("pending");
  const history = useHistory();

  const onclickSeeTutorial = (e) => {
    e && e.preventDefault();
    history.push(HREF_PAGE_HELP + "?guide_category_id=8&article_id=10");
  };

  return (
    <>
      {!points_of_sale?.length && (
        <div className="alert alert-outline-primary fade show" role="alert">
          <div className="alert-icon d-none d-lg-inline">
            <i className="flaticon-warning"></i>
          </div>
          <div className="alert-text text-center text-lg-left">Para emitir tus facturas, debes dar de alta un punto de
            venta compatible en ARCA.
          </div>
          <div className="d-inline-block m-2 float-none float-lg-right">
            <a className="btn btn-accent" href="#" onClick={onclickSeeTutorial}>
              Tutorial en 3 simples pasos.
            </a>
          </div>
        </div>
      )}
      <ul className="nav nav-tabs m-0">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "pending" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("pending");
            }}
          >
            Pendientes
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "invoices" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("invoices");
            }}
          >
            Facturados
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "settings" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("settings");
            }}
          >
            Configuración
          </a>
        </li>
      </ul>
      <div className="tab-content border border-top-0 bg-white overflow-auto">
        {activeTab === "pending" && <PendingBilling />}
        {activeTab === "invoices" && <Invoices />}
        {activeTab === "settings" && <Settings/>}
      </div>
    </>
  );
}
